import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const RADIUS = 56;

const style = () => {
  const { colorText, colorBgBase, borderRadiusFull } = theme();

  return StyleSheet.create({
    button: {
      alignItems: "center",
      backgroundColor: colorText,
      borderRadius: borderRadiusFull,
      height: RADIUS,
      justifyContent: "center",
      width: RADIUS,
    },
    icon: {
      color: colorBgBase,
    },
  });
};

export { style };
